"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return function (value) {
    return Math.ceil(value);
  };
};


// WEBPACK FOOTER //
// ./client/components/filters/roundUp.js